import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=0b7e98cc&"
import script from "./MainDialog.vue?vue&type=script&lang=js&"
export * from "./MainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainDialog.vue"
export default component.exports